import { getApiClient } from "@src/api";
import { graphql } from "@src/gql";
import { queryOptions, useQuery } from "@tanstack/react-query";

const getAuth0UserQuery = graphql(/* GraphQL */ `
	query GetAuth0User {
		users {
			auth0User {
				email
				emailVerified
				name
				picture
				userId
			}
		}
	}
`);

async function fetchAuth0User() {
	const client = getApiClient();
	const response = await client.query({
		query: getAuth0UserQuery,
	});

	return response.data.users.auth0User ?? null;
}

export const auth0UserQueryKey = ["auth0-user"] as const;

export const auth0UserQueryOptions = queryOptions({
	queryKey: auth0UserQueryKey,
	queryFn: fetchAuth0User,
	staleTime: 0,
});

export function useAuth0User(enabled = true) {
	return useQuery({
		...auth0UserQueryOptions,
		enabled,
	});
}
